"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var title_container_1 = __importDefault(require("../views/title-container"));
var sheet_1 = __importDefault(require("../views/sheet"));
var game_area_1 = require("../utilities/game-area");
var stack_container_1 = __importStar(require("../views/stack-container"));
var category_button_1 = __importDefault(require("../views/category-button"));
var customize_element_button_1 = __importStar(require("../views/customize-element-button"));
var page_button_1 = __importStar(require("../views/page-button"));
var customize_1 = require("../models/customize");
var gsap_1 = require("gsap");
var PixiPlugin_1 = require("gsap/PixiPlugin");
var i18next_1 = __importDefault(require("i18next"));
gsap_1.gsap.registerPlugin(PixiPlugin_1.PixiPlugin);
PixiPlugin_1.PixiPlugin.registerPIXI(PIXI);
var CUSTOMIZE_ELEMENTS_ROWS = 2;
var CUSTOMIZE_ELEMENTS_COLUMNS = 4;
var CUSTOMIZE_ELEMENTS_COUNT = CUSTOMIZE_ELEMENTS_ROWS * CUSTOMIZE_ELEMENTS_COLUMNS;
var CustomizeState = /** @class */ (function (_super) {
    __extends(CustomizeState, _super);
    function CustomizeState(app, client, backdropContainer, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._backdropContainer = backdropContainer;
        _this._dragonContainer = dragonContainer;
        return _this;
    }
    Object.defineProperty(CustomizeState.prototype, "backButton", {
        get: function () {
            if (!this._backButton) {
                this._backButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.BACK, this.hideSheet.bind(this));
                this._backButton.position.set(game_area_1.GAME_SAFE_AREA.left + 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._backButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomizeState.prototype, "titleContainer", {
        get: function () {
            if (!this._titleContainer) {
                this._titleContainer = new title_container_1.default(this._app.loader.resources.ui.textures);
                this._titleContainer.setText(i18next_1.default.t("customize_title"));
                this._titleContainer.position.set((game_area_1.GAME_WIDTH - this._titleContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._titleContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomizeState.prototype, "sheet", {
        get: function () {
            if (!this._sheet) {
                this._sheet = new sheet_1.default(this._app.loader.resources.ui.textures);
                this._sheet.contentContainer.addChild(this.stackContainer);
                this._sheet.contentContainer.addChild(this.previousPageButton);
                this._sheet.contentContainer.addChild(this.nextPageButton);
            }
            return this._sheet;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomizeState.prototype, "categoryButtons", {
        get: function () {
            var e_1, _a;
            if (!this._categoryButtons) {
                this._categoryButtons = [];
                try {
                    for (var _b = __values(Object.keys(customize_1.CUSTOMIZE_CATEGORIES)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var categoryID = _c.value;
                        var category = customize_1.CUSTOMIZE_CATEGORIES[categoryID];
                        var button = new category_button_1.default(this._app.loader.resources.ui.textures, categoryID, this.onCategory.bind(this));
                        this.categoryButtons.push(button);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            return this._categoryButtons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomizeState.prototype, "categoryContainer", {
        get: function () {
            if (!this._categoryContainer) {
                this._categoryContainer = new stack_container_1.default(this.categoryButtons, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.HORIZONTAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 12
                });
            }
            return this._categoryContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomizeState.prototype, "elementButtons", {
        get: function () {
            if (!this._elementButtons) {
                this._elementButtons = [];
                for (var i = 0; i < CUSTOMIZE_ELEMENTS_COUNT; i++) {
                    var button = new customize_element_button_1.default(this.onElement.bind(this));
                    this._elementButtons.push(button);
                }
            }
            return this._elementButtons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomizeState.prototype, "elementContainer", {
        get: function () {
            if (!this._elementContainer) {
                this._elementContainer = stack_container_1.default.Group(this.elementButtons, CUSTOMIZE_ELEMENTS_COLUMNS, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.HORIZONTAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: -8,
                }, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: -8,
                });
            }
            return this._elementContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomizeState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.categoryContainer,
                    this.elementContainer
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 18,
                    minWidth: game_area_1.GAME_WIDTH
                });
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomizeState.prototype, "previousPageButton", {
        get: function () {
            if (!this._previousPageButton) {
                this._previousPageButton = new page_button_1.default(this._app.loader.resources.ui.textures, page_button_1.PAGE_BUTTON_TYPE.PREVIOUS, this.onPreviousPage.bind(this));
                this._previousPageButton.position.set(game_area_1.GAME_SAFE_AREA.left, this.elementContainer.y + ((this.elementContainer.height - this.previousPageButton.height) * 0.5));
            }
            return this._previousPageButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomizeState.prototype, "nextPageButton", {
        get: function () {
            if (!this._nextPageButton) {
                this._nextPageButton = new page_button_1.default(this._app.loader.resources.ui.textures, page_button_1.PAGE_BUTTON_TYPE.NEXT, this.onNextPage.bind(this));
                this._nextPageButton.position.set(game_area_1.GAME_SAFE_AREA.right - this.nextPageButton.width, this.elementContainer.y + ((this.elementContainer.height - this.nextPageButton.height) * 0.5));
            }
            return this._nextPageButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomizeState.prototype, "currentPage", {
        get: function () {
            return this._currentPage;
        },
        set: function (value) {
            if (!this.isValidPage(value)) {
                return;
            }
            this._currentPage = value;
            this.previousPageButton.visible = this.isValidPage(value - 1);
            this.nextPageButton.visible = this.isValidPage(value + 1);
            this.updateElements();
            this._client.sendEvent("customize_paged", {
                category: this._selectedCategoryID,
                current: value + 1,
                total: this._numberOfPages,
            });
        },
        enumerable: false,
        configurable: true
    });
    CustomizeState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this._backdropContainer);
        this._app.stage.addChild(this.backButton);
        this._app.stage.addChild(this.titleContainer);
        this._app.stage.addChild(this.sheet);
        this._dragonContainer.setIdleAnimation();
        this._backdropContainer.dragonSlot.addChild(this._dragonContainer);
        this.showSheet();
        this._client.sendEvent("customize_entered");
    };
    CustomizeState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this._backdropContainer);
        this._app.stage.removeChild(this.backButton);
        this._app.stage.removeChild(this.titleContainer);
        this._app.stage.removeChild(this.sheet);
        this._backdropContainer.dragonSlot.removeChild(this._dragonContainer);
    };
    CustomizeState.prototype.showSheet = function () {
        var _a;
        var categoryID = (_a = (0, customize_1.latestUnlockedCategory)(this._client.dragon.status.stage)) !== null && _a !== void 0 ? _a : Object.keys(customize_1.CUSTOMIZE_CATEGORIES)[0];
        this.setSelectedCategory(categoryID, false);
        this.sheet.show(false, false);
        this.sheet.show(true, true);
    };
    CustomizeState.prototype.hideSheet = function () {
        var _this = this;
        this.sheet.show(false, true, function () {
            _this.stateMachine.pop();
        });
    };
    CustomizeState.prototype.updateCategories = function (animated) {
        for (var i = 0; i < this.categoryButtons.length; i++) {
            var button = this.categoryButtons[i];
            var categoryID = Object.keys(customize_1.CUSTOMIZE_CATEGORIES)[i];
            var category = customize_1.CUSTOMIZE_CATEGORIES[categoryID];
            button.locked = this._client.dragon.status.stage < category.requiredStage;
            button.selected = categoryID == this._selectedCategoryID;
            if (categoryID == this._selectedCategoryID) {
                var x = (game_area_1.GAME_WIDTH * 0.5) - button.x - (button.width * 0.5);
                if (animated) {
                    gsap_1.gsap.to(this.categoryContainer, {
                        duration: 0.3,
                        x: x,
                        ease: "Power1.easeInOut"
                    });
                }
                else {
                    this.categoryContainer.x = x;
                }
            }
        }
    };
    CustomizeState.prototype.updateElements = function () {
        var _a, _b;
        var category = customize_1.CUSTOMIZE_CATEGORIES[this._selectedCategoryID];
        var categoryUnlocked = this._client.dragon.status.stage >= category.requiredStage;
        var elements = category.elements;
        var elementIDs = Object.keys(elements);
        for (var i = 0; i < this.elementButtons.length; i++) {
            var button = this.elementButtons[i];
            var elementIndex = this.currentPage * CUSTOMIZE_ELEMENTS_COUNT + i;
            button.alpha = elementIndex < elementIDs.length ? 1 : 0;
            if (button.alpha == 0) {
                continue;
            }
            var elementID = elementIDs[elementIndex];
            var element = elements[elementID];
            var texture = this._app.loader.resources.ui.textures["customize_" + this._selectedCategoryID + "_" + ((_a = element.resourceName) !== null && _a !== void 0 ? _a : elementID) + ".png"];
            button.setTexture(texture);
            if (element.colorCategory) {
                var colorID = this._client.dragon.appearance[element.colorCategory];
                var colorElement = customize_1.CUSTOMIZE_CATEGORIES[element.colorCategory].elements[colorID];
                button.setColor(colorElement.color);
            }
            else {
                button.setColor(element.color);
            }
            var selectedElement = this._client.dragon.appearance[this._selectedCategoryID];
            var unlockedElements = (_b = this._client.dragon.unlocks[this._selectedCategoryID]) !== null && _b !== void 0 ? _b : [];
            var elementUnlocked = unlockedElements.includes(elementID);
            if (!categoryUnlocked && elementUnlocked) {
                button.setState(customize_element_button_1.CUSTOMIZE_ELEMENT_BUTTON_STATE.DISCOVERED);
            }
            else if (!elementUnlocked) {
                button.setState(customize_element_button_1.CUSTOMIZE_ELEMENT_BUTTON_STATE.UNDISCOVERED);
            }
            else if (elementID == selectedElement) {
                button.setState(customize_element_button_1.CUSTOMIZE_ELEMENT_BUTTON_STATE.SELECTED);
            }
            else {
                button.setState(customize_element_button_1.CUSTOMIZE_ELEMENT_BUTTON_STATE.UNSELECTED);
            }
        }
    };
    CustomizeState.prototype.isValidPage = function (page) {
        return page >= 0 && page <= this._numberOfPages - 1;
    };
    CustomizeState.prototype.setSelectedCategory = function (categoryID, animated) {
        this._selectedCategoryID = categoryID;
        this.updateCategories(animated);
        var numberOfPages = 1;
        var category = customize_1.CUSTOMIZE_CATEGORIES[this._selectedCategoryID];
        var elementIDs = Object.keys(category.elements);
        if (elementIDs.length != 0) {
            numberOfPages = Math.ceil(elementIDs.length / CUSTOMIZE_ELEMENTS_COUNT);
        }
        this._numberOfPages = numberOfPages;
        var page = 0;
        var selectedElement = this._client.dragon.appearance[this._selectedCategoryID];
        var elementIndex = elementIDs.indexOf(selectedElement);
        if (elementIndex != -1) {
            page = Math.floor(elementIndex / CUSTOMIZE_ELEMENTS_COUNT);
        }
        this.currentPage = page;
    };
    CustomizeState.prototype.onCategory = function (button) {
        var index = this.categoryButtons.indexOf(button);
        var categoryID = Object.keys(customize_1.CUSTOMIZE_CATEGORIES)[index];
        this.setSelectedCategory(categoryID, true);
    };
    CustomizeState.prototype.onElement = function (button) {
        var _a;
        var category = customize_1.CUSTOMIZE_CATEGORIES[this._selectedCategoryID];
        var categoryUnlocked = this._client.dragon.status.stage >= category.requiredStage;
        if (!categoryUnlocked) {
            return;
        }
        var buttonIndex = this.elementButtons.indexOf(button);
        var elementIndex = this.currentPage * CUSTOMIZE_ELEMENTS_COUNT + buttonIndex;
        var elementIDs = Object.keys(category.elements);
        if (elementIndex >= elementIDs.length) {
            return;
        }
        var elementID = elementIDs[elementIndex];
        var unlockedElements = (_a = this._client.dragon.unlocks[this._selectedCategoryID]) !== null && _a !== void 0 ? _a : [];
        var elementUnlocked = unlockedElements.includes(elementID);
        if (!elementUnlocked) {
            return;
        }
        this._client.dragon.appearance[this._selectedCategoryID] = elementID;
        this._client.synchronize();
        this._client.sendEvent("customize_changed", {
            category: this._selectedCategoryID,
            element: elementID,
            dragon: this._client.dragon
        });
        this.updateElements();
    };
    CustomizeState.prototype.onPreviousPage = function () {
        this.currentPage -= 1;
    };
    CustomizeState.prototype.onNextPage = function () {
        this.currentPage += 1;
    };
    return CustomizeState;
}(state_1.default));
exports.default = CustomizeState;
